export const PORTAL_TYPES = ["grower", "partner", "aggregator", "admin"];

export const PRODUCTION_PORTAL_HOSTS = {
  grower: "calculator.fieldtomarket.ca",
  partner: "partners.calculator.fieldtomarket.ca",
  aggregator: "aggregators.calculator.fieldtomarket.ca",
  admin: "admin.calculator.fieldtomarket.ca",
};

// CRA embeds these public settings in each bundle. They select the UI and link
// destinations; session/viewer and the API still decide what a user can access.
export function getPortalConfiguration(env = process.env) {
  const portal = (env.REACT_APP_PORTAL || "").trim().toLowerCase();
  if (portal && !PORTAL_TYPES.includes(portal)) {
    throw new Error("REACT_APP_PORTAL must be grower, partner, aggregator or admin");
  }

  const origins = Object.fromEntries(PORTAL_TYPES.map((type) => {
    const name = `REACT_APP_${type.toUpperCase()}_PORTAL_URL`;
    const value = (env[name] || `https://${PRODUCTION_PORTAL_HOSTS[type]}`).trim();
    let url;
    try {
      url = new URL(value);
    } catch {
      throw new Error(`${name} must be an absolute HTTPS origin`);
    }
    if (url.protocol !== "https:" || url.username || url.password ||
        url.pathname !== "/" || url.search || url.hash) {
      throw new Error(`${name} must be an absolute HTTPS origin without a path`);
    }
    return [type, url.origin];
  }));

  return { portal: portal || null, origins };
}
